<template>
  <div
    class="hotel-name-stars"
    :class="{ standalone }"
  >
    <span
      v-if="hotelName"
      class="hotel-name-stars__name"
      :class="{'text-small': textSmall}"
    >
      <span v-if="standalone">{{ hotelName }}</span>
      <Lang
        v-else
        by-key="XX-in-XX"
        :params="{left: '' ,right: hotelName}"
      />

      <span v-if="inlineStars">{{ inlineStarsText }}</span>
    </span>
    <div
      v-if="hotel.category && !inlineStars"
      class="hotel-name-stars__stars"
    >
      <HotelRating
        :size="starSize"
        :amount="hotel.category"
      />
    </div>
  </div>
</template>

<script lang="ts">
import type { Spa } from '~/core/ts/entity/Spa'
import HotelRating from './HotelRating.atom.vue'

export default defineNuxtComponent({
  components: {
    HotelRating
  },
  props: {
    hotel: {
      required: true,
      type: Object as PropType<Spa['hotel']>
    },
    starSize: {
      type: Number,
      default: 12
    },
    textSmall: {
      type: Boolean,
      default: false
    },
    inlineStars: {
      type: Boolean,
      default: false
    },
    standalone: {
      type: Boolean,
      default: false
    },
  },
  setup(props) {
    const hotelName = props.hotel?.name || ''

    const inlineStarsText = (() => {
      if (!props.hotel.category) {
        return ''
      }

      const startCount = Math.floor(props.hotel.category)
      const starsList = []
      for (let i = 0; i < startCount; i++) {
        starsList.push('★')
      }

      return starsList.join('')
    })()

    return {
      hotelName,
      inlineStarsText,
    }
  },
})
</script>

<style lang="scss" scoped>
.hotel-name-stars {
  @apply flex;
  @apply flex-row flex-wrap items-center;
  @apply text-lg;
  @apply text-gray-900;
  @apply my-1;

  &__name {
    @apply mr-1;

    @screen lg {
      @apply text-xl;
    }
  }

  @screen sm {
    &__name {
      @apply mb-0;
    }
    @apply flex-row;
  }

  @screen lg {
    @apply items-center;
  }
}
.text-small {
  @apply text-spl-gray-4;

  @apply font-semibold;

  @screen lg {
    font-size: 12px;
    margin-right: 13px;
  }
}
.standalone {
  .hotel-name-stars__name {
    @apply text-xl;
    @apply font-semibold;
  }
}
</style>
